import React from "react";
import { Form, Input, Button, message } from "antd";
import emailjs from "@emailjs/browser";
import "./ContactForm.css";

// Destructure TextArea from Input
const { TextArea } = Input;

const ContactForm = () => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const templateParams = {
        user_name: values.user_name,
        user_phone: values.user_phone,
        user_email: values.user_email,
        message: values.message,
      };

      console.log("Attempting to send email with params:", templateParams);

      const result = await emailjs.send(
        "service_2tshwjk",
        "template_lnw04cp",
        templateParams,
        "eSROwPSPveI1cqT4H"
      );

      console.log("Email sent successfully:", result);
      message.success("Message sent successfully!");
      form.resetFields();
    } catch (error) {
      console.error("Detailed error:", error);
      message.error(
        `Failed to send message: ${
          error.text || error.message || "Unknown error"
        }`
      );
    }
  };

  return (
    <div className="contact-form">
      <h2>Come Stay At The Oasis</h2>
      <Form
        form={form}
        name="contact_form"
        onFinish={onFinish}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Form.Item
          label="Name"
          name="user_name"
          rules={[{ required: true, message: "Please enter your name" }]}
          style={{ width: "100%" }}
        >
          <Input style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="user_phone"
          rules={[
            { required: true, message: "Please enter your phone number" },
          ]}
          style={{ width: "100%" }}
        >
          <Input style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="E-Mail Address"
          name="user_email"
          rules={[
            { required: true, message: "Please enter your e-mail address" },
            { type: "email", message: "Please enter a valid e-mail address" },
          ]}
          style={{ width: "100%" }}
        >
          <Input style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Additional Details"
          name="message"
          rules={[
            {
              required: true,
              message: "Please provide some background information",
            },
          ]}
          style={{ width: "100%" }}
        >
          <TextArea
            rows={4}
            style={{ width: "100%" }}
            placeholder="Provide details about your desired rental dates, group size, etc."
          />
        </Form.Item>

        <Form.Item style={{ width: "100%" }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ContactForm;
